import React from 'react';
import cl from './ShipmentFilterPanelCheckboxSection.module.css';
import {useParams} from "react-router-dom";
import Checkbox, {CheckboxSize} from "../../../../../../../components/ui/Checkbox/Checkbox";
import {useGridLayoutContext} from "../../../../../../../components/uiLayouts/GridLayout/hooks/useGridLayoutContext";
import {IShipmentHeaderConfig} from "../../../data/interfaces/IShipmentHeaderConfig";
import {useTranslation} from "react-i18next";
import {useAppSelector} from "../../../../../../../app/store";
import {selectCurrentUser} from "../../../../../../../features/authentication/authenticationSliceSelectors";
import {getUserRole} from "../../../../../../../helpers/user";
import {UserRole} from "../../../../../../../app/enums/UserRole";

const ShipmentFilterPanelCheckboxSection = () => {
    const {t} = useTranslation();
    const {type} = useParams();
    const user = useAppSelector(selectCurrentUser);

    const {
        headerConfig,
        isHeaderDisabled,
        saveHeaderConfig,
    } = useGridLayoutContext<IShipmentHeaderConfig>();

    if (!type || !headerConfig || !user || getUserRole(user) === UserRole.Client || getUserRole(user) === UserRole.ServiceProvider) {
        return null;
    }

    const onChange = (config: IShipmentHeaderConfig) => {
        (async () => {
            await saveHeaderConfig(config);
        })();
    }

    return (
        <div className={cl.container}>
            {type === 'current' &&
                <>
                    <Checkbox checked={headerConfig.showOnlyCurrent}
                              size={CheckboxSize.Medium}
                              label={t("shared.grid-header.show-only-current")}
                              change={(val) => {
                                  onChange({
                                      ...headerConfig,
                                      showOnlyCurrent: val
                                  });
                              }}
                              disabled={isHeaderDisabled}/>
                </>
            }

            <div className={cl.checkboxesContainer}>
                <Checkbox checked={headerConfig.CM}
                          size={CheckboxSize.Medium}
                          label={t("shared.grid-header.cm")}
                          change={(val) => {
                              onChange({
                                  ...headerConfig,
                                  CM: val
                              });
                          }}
                          disabled={isHeaderDisabled}/>
                <Checkbox checked={headerConfig.TLM}
                          size={CheckboxSize.Medium}
                          label={t("shared.grid-header.tlm")}
                          change={(val) => {
                              onChange({
                                  ...headerConfig,
                                  TLM: val
                              });
                          }}
                          disabled={isHeaderDisabled}/>
                <Checkbox checked={headerConfig.SMFA}
                          size={CheckboxSize.Medium}
                          label={t("shared.grid-header.sm-fa")}
                          change={(val) => {
                              onChange({
                                  ...headerConfig,
                                  SMFA: val
                              });
                          }}
                          disabled={isHeaderDisabled}/>
                <Checkbox checked={headerConfig.SMEXA}
                          size={CheckboxSize.Medium}
                          label={t("shared.grid-header.sm-exa")}
                          change={(val) => {
                              onChange({
                                  ...headerConfig,
                                  SMEXA: val
                              });
                          }}
                          disabled={isHeaderDisabled}/>
                <Checkbox checked={headerConfig.OM}
                          size={CheckboxSize.Medium}
                          label={t("shared.grid-header.om")}
                          change={(val) => {
                              onChange({
                                  ...headerConfig,
                                  OM: val
                              });
                          }}
                          disabled={isHeaderDisabled}/>

            </div>
        </div>
    );
};

export default ShipmentFilterPanelCheckboxSection;
